import { HTMLTable } from '@blueprintjs/core';
import * as React from 'react';

import { FilterableItem } from 'src/components/FilterableCollapsibleBlock';
import { TableColumnChildren } from 'src/containers/ProjectDiagram/components/resourceDrawer/TableItemRenderer';

export type TableWrapperProps<ItemType extends FilterableItem> = {
  children: React.ReactNode;
  columns: TableColumnChildren<ItemType>;
  testId?: string;
};

export const TableWrapper = <ItemType extends FilterableItem>({
  children,
  columns,
  testId,
}: TableWrapperProps<ItemType>) => (
  <HTMLTable
    bordered={false}
    className="sd-table-drawer"
    condensed
    data-testid={testId}
  >
    <thead>
      <tr>{columns}</tr>
    </thead>
    <tbody>{children}</tbody>
  </HTMLTable>
);
